import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getCarModelList = createAsyncThunk(
  'general/getCarModelList',
  async (formData = {}, { rejectWithValue }) => {
    try {
      return await authSet(METHOD_POST, '/general/list/carModel', formData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getCarModelList;
